export default __webpack_public_path__ + "static/media/stats2.f938b8ee.png";